import apiClient, { tokenStorage } from './client';
import { ApiResponse, AuthResult } from '@/types';

/**
 * Login with username and password
 */
export async function login(username: string, password: string): Promise<AuthResult> {
  const response = await apiClient.post<ApiResponse<AuthResult>>('/auth/login', {
    username,
    password,
  });

  if (response.data.success && response.data.data) {
    const { tokens } = response.data.data;
    tokenStorage.setTokens(tokens.accessToken, tokens.refreshToken);
    return response.data.data;
  }

  throw new Error(response.data.error?.message || 'Login failed');
}

/**
 * Logout
 */
export async function logout(): Promise<void> {
  const refreshToken = tokenStorage.getRefreshToken();

  try {
    await apiClient.post('/auth/logout', { refreshToken });
  } finally {
    tokenStorage.clearTokens();
  }
}

/**
 * Get current user
 */
export async function getCurrentUser(): Promise<{ userId: string; username: string; role: string }> {
  const response = await apiClient.get<ApiResponse<{ userId: string; username: string; role: string }>>('/auth/me');

  if (response.data.success && response.data.data) {
    return response.data.data;
  }

  throw new Error(response.data.error?.message || 'Failed to get current user');
}

/**
 * Check if user is authenticated
 */
export function isAuthenticated(): boolean {
  return !!tokenStorage.getAccessToken();
}
